import useAxiosPrivate from "../../api/hooks/useAxiosPrivate"
import apiEndpoints from "api/utils/apiEndpoints"
import fileDownload from "utilities/fileDownload"
import getUrl from "api/apiMap"
import useAppState from "../../context/hooks/useAppState"

// PR NOTES: please move these utilities to  to fileUtils in /utilities
// Update all files importing these functions and delete this file after

const isPdf = (file) => {
  return file?.document_file && file.document_file.toLowerCase().includes(".pdf")
}

const useDownloadFile = () => {
  const axios = useAxiosPrivate()
  const { openToastNotification } = useAppState()

  const downloadFile = (document) => {
    const fileName = document.name
    openToastNotification("info", "Info", "Downloading file in progress")

    if (isPdf(document)) {
      axios
        .get(`${getUrl(apiEndpoints.documents)}${document.id}/download/`, {
          responseType: "arraybuffer",
        })
        .then(({ data }) => {
          const type = "application/pdf"
          const blob = new Blob([data], { type })
          fileDownload(blob, fileName, type)
          openToastNotification("success", "Success", "Successfully downloaded file")
        })
        .catch((err) => {
          console.error(err)
          openToastNotification("error", "Error", "Error fetching file")
        })
    } else {
      const url = document.document_file
      fetch(url)
        .then((r) => r.blob())
        .catch((err) => {
          console.error(err)
        })
        .then((blob) => {
          fileDownload(blob, fileName, blob?.type)
          openToastNotification("success", "Success", "Successfully downloaded file")
        })
        .catch((error) => {
          openToastNotification("error", "Error", "Error fetching file")
        })
    }
  }

  return {
    downloadFile,
  }
}

export default useDownloadFile
